import { atob } from 'js-base64';
export const decodeBase64 = (input) => {
    return atob(input);
};
//# sourceMappingURL=decodeBase64.js.map